import { useState } from "react";

function Bannerimages() {
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState(""); // "add" or "edit"

    const handleOpenModal = (type) => {
        setModalType(type);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setModalType("");
    };

    return (
        <div>
            <div className="container-fluid">
                <div className="row justify-content-center">
                    <div className="col-lg-2"></div>
                    <div className="col-12 col-lg-10" style={{ marginTop: "135px" }}>
                        <div>
                            <button
                                className="btn"
                                style={{ backgroundColor: "#b15cd6", color: "#fff" }}
                                onClick={() => handleOpenModal("add")}
                            >
                                Add
                            </button>
                        </div>
                        <div>
                            <table className="table table-bordered mt-3">
                                <thead style={{ backgroundColor: "#b15cd6", color: "#fff" }}>
                                    <tr style={{ backgroundColor: "#b15cd6" }}>
                                        <th scope="col" style={{ backgroundColor: "#b15cd6", color: "#fff" }}>SNO</th>
                                        <th scope="col" style={{ backgroundColor: "#b15cd6", color: "#fff" }}>Banner Image</th>
                                        <th scope="col" style={{ backgroundColor: "#b15cd6", color: "#fff" }}>Image One</th>
                                        <th scope="col" style={{ backgroundColor: "#b15cd6", color: "#fff" }}>Image Two</th>
                                        <th scope="col" style={{ backgroundColor: "#b15cd6", color: "#fff" }}>Image Three</th>
                                        <th scope="col" style={{ backgroundColor: "#b15cd6", color: "#fff" }}>Description One</th>
                                        <th scope="col" style={{ backgroundColor: "#b15cd6", color: "#fff" }}>Description Two</th>
                                        <th scope="col" style={{ backgroundColor: "#b15cd6", color: "#fff" }}>Description Three</th>
                                        <th scope="col" style={{ backgroundColor: "#b15cd6", color: "#fff" }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td>
                                            <button
                                                className="btn btn-info"
                                                onClick={() => handleOpenModal("edit")}
                                            >
                                                Edit
                                            </button>
                                            <button className="btn btn-danger ms-2">Delete</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {/* Responsive Bootstrap Modal */}
            {showModal && (
                <div
                    className="modal fade show"
                    tabIndex="-1"
                    style={{
                        display: "block",
                        background: "rgba(0,0,0,0.5)",
                        position: "fixed",
                        top: 64,
                        left: 0,
                        width: "100vw",
                        height: "80vh",
                        zIndex: 1050,
                        overflowY: "auto"
                    }}
                    onClick={handleCloseModal}
                    aria-modal="true"
                    role="dialog"
                >
                    <div
                        className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-sm modal-md modal-lg"
                        style={{
                            maxWidth: "100vw",
                            // width: "50%",
                            margin: "auto",
                            minHeight: "80vh",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "70px"
                        }}
                        onClick={e => e.stopPropagation()}
                    >
                        <div className="modal-content" style={{ borderRadius: 8, padding: 0, width: "100%" }}>
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    {modalType === "add" ? "Add Details" : "Edit Details"}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={handleCloseModal}
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-12">
                                            <label className="form-label fw-bold d-flex jusitify-content-start">Banner Image</label>
                                            <input type="file" accept="image/*" className="form-control mb-2" />

                                            <label className="form-label fw-bold d-flex jusitify-content-start">Image One</label>
                                            <input type="file" accept="image/*" className="form-control mb-2" />

                                            <label className="form-label fw-bold d-flex jusitify-content-start">Image Two</label>
                                            <input type="file" accept="image/*" className="form-control mb-2" />

                                            <label className="form-label fw-bold d-flex jusitify-content-start">Image Three</label>
                                            <input type="file" accept="image/*" className="form-control mb-2" />

                                            <input className="form-control mb-2" placeholder="Description One" />
                                            <input className="form-control mb-2" placeholder="Description Two" />
                                            <input className="form-control mb-2" placeholder="Description Three" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={handleCloseModal}>
                                    Close
                                </button>
                                <button className="btn btn-primary">
                                    {modalType === "add" ? "Add" : "Save"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Bannerimages;
